module.exports = __webpack_public_path__ + "img/horizontal_7_3_8004.1772f957.png";